import {CurrentPresentation} from "@api/models/interfaces/web-conference/CurrentPresentation";
import {EventBus} from "@common/EventBus";

export const EventTypes = {
    playerInitialized: 'WebConferenceInitialized',
    sharingChanged: 'WebConferenceSharingChanged'
}

export const getEventKey = (prefix: string, schemaId: string, objectId: string): string => {
    return `${prefix}_${schemaId}_${objectId}`.toLowerCase();
}

export const fireInitializedEvent = (schemaId: string, objectId: string) => {
    const eventKey = getEventKey(EventTypes.playerInitialized, schemaId, objectId);
    EventBus.$emit(eventKey);
}

export const fireSharingChanged = (schemaId: string, objectId: string, currentPresentation: CurrentPresentation | null) => {
    console.log('fire sharing event');
    const eventKey = getEventKey(EventTypes.sharingChanged, schemaId, objectId);
    EventBus.$emit(eventKey, currentPresentation);
}
